import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = {
  key: 0,
  d: "M676.032 142.72l-60.928 33.28 60.928 33.28 33.28 60.992 33.28-60.928 60.992-33.344-60.928-33.28-33.28-60.992-33.344 60.928z m-231.808 34.688A341.44 341.44 0 0 0 512 853.312a341.248 341.248 0 0 0 295.68-170.688 384 384 0 0 1-380.992-384c0-41.728 5.568-82.56 17.536-121.216zM85.312 512A426.688 426.688 0 0 1 512 85.312h73.984l-37.056 64C524.224 192.128 512 242.816 512 298.752a298.688 298.688 0 0 0 356.16 293.12l71.808-13.952-23.168 69.376A426.688 426.688 0 0 1 85.376 512z m789.376-238.272l38.976 71.296L984.896 384l-71.232 39.04-39.04 71.232-38.976-71.296L764.416 384l71.232-38.976 39.04-71.296z",
  fill: "currentColor"
}
const _hoisted_3 = {
  key: 1,
  d: "M512.1 743.5c-127.6 0-231.4-103.8-231.4-231.4s103.8-231.4 231.4-231.4 231.4 103.8 231.4 231.4-103.8 231.4-231.4 231.4z m0-393.4c-89.3 0-162 72.7-162 162s72.7 162 162 162 162-72.7 162-162-72.7-162-162-162zM512.1 227.1c-19.2 0-34.7-15.5-34.7-34.7V98.7c0-19.2 15.5-34.7 34.7-34.7 19.2 0 34.7 15.5 34.7 34.7v93.7c0 19.1-15.5 34.7-34.7 34.7zM286 320.7c-8.9 0-17.8-3.4-24.5-10.2l-66.3-66.3c-13.6-13.6-13.6-35.5 0-49.1 13.5-13.6 35.5-13.6 49.1 0l66.3 66.3c13.6 13.6 13.6 35.5 0 49.1a34.68 34.68 0 0 1-24.6 10.2zM192.4 546.8H98.7c-19.2 0-34.7-15.5-34.7-34.7 0-19.2 15.5-34.7 34.7-34.7h93.7c19.2 0 34.7 15.5 34.7 34.7 0 19.1-15.5 34.7-34.7 34.7zM219.8 839.1c-8.9 0-17.8-3.4-24.5-10.2-13.6-13.6-13.6-35.5 0-49.1l66.3-66.3c13.5-13.6 35.5-13.6 49.1 0 13.6 13.6 13.6 35.5 0 49.1l-66.3 66.3c-6.9 6.8-15.7 10.2-24.6 10.2zM512.1 960.2c-19.2 0-34.7-15.5-34.7-34.7v-93.7c0-19.2 15.5-34.7 34.7-34.7 19.2 0 34.7 15.5 34.7 34.7v93.7c0 19.2-15.5 34.7-34.7 34.7zM804.4 839.1c-8.9 0-17.8-3.4-24.5-10.2l-66.3-66.3c-13.6-13.6-13.6-35.5 0-49.1 13.5-13.6 35.5-13.6 49.1 0l66.3 66.3c13.6 13.6 13.6 35.5 0 49.1a34.68 34.68 0 0 1-24.6 10.2zM925.5 546.8h-93.7c-19.2 0-34.7-15.5-34.7-34.7 0-19.2 15.5-34.7 34.7-34.7h93.7c19.2 0 34.7 15.5 34.7 34.7 0 19.1-15.5 34.7-34.7 34.7zM738.2 320.7c-8.9 0-17.8-3.4-24.5-10.2-13.6-13.6-13.6-35.5 0-49.1l66.3-66.3c13.5-13.6 35.5-13.6 49.1 0 13.6 13.6 13.6 35.5 0 49.1l-66.3 66.3c-6.9 6.8-15.8 10.2-24.6 10.2z",
  fill: "currentColor"
}
const _hoisted_4 = {
  key: 2,
  d: "M512 938.666667c235.648 0 426.666667-191.018667 426.666667-426.666667S747.648 85.333333 512 85.333333 85.333333 276.352 85.333333 512s191.018667 426.666667 426.666667 426.666667z m0-85.333334V170.666667a341.333333 341.333333 0 1 1 0 682.666666z",
  fill: "currentColor"
}

import type { PropType } from 'vue'
import type { AppThemeMode } from '@/utils/app-theme'


export default /*#__PURE__*/_defineComponent({
  __name: 'theme-mode-icon',
  props: {
  /** 主题模式：dark 星月 / light 太阳 / system 半明半暗 */
  mode: {
    type: String as PropType<AppThemeMode>,
    default: 'system',
  },
  /** 图标边长，默认 22px */
  size: {
    type: [Number, String] as PropType<number | string>,
    default: 22,
  },
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    class: "theme-mode-icon",
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: __props.size,
    height: __props.size,
    "aria-hidden": "true"
  }, [
    (__props.mode === 'dark')
      ? (_openBlock(), _createElementBlock("path", _hoisted_2))
      : (__props.mode === 'light')
        ? (_openBlock(), _createElementBlock("path", _hoisted_3))
        : (_openBlock(), _createElementBlock("path", _hoisted_4))
  ], 8, _hoisted_1))
}
}

})